import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

// Se elimina: import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];

    // Corregido: elegir correctamente entre publicData y metadata
    const value = publicDataValue !== undefined ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = v =>
        v
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      {/* Reemplazo de Heading por <p> para evitar negritas */}
      <p className={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </p>

      <ul className={css.details}>
        {existingListingFields.map(detail => {
          const isRoleRow =
            typeof detail.label === 'string' &&
            detail.label.trim().toLowerCase() === 'elige tu rol';

          return (
            <li key={detail.key} className={css.detailsRow}>
              <span className={isRoleRow ? css.detailLabelNormal : css.detailLabel}>
                {isRoleRow ? detail.value : detail.label}
              </span>
              {!isRoleRow ? <span>{detail.value}</span> : null}
            </li>
          );
        })}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
